import { getAuthToken } from '@/libs/auth-helper'
import store from '@/store'
import { account, site } from './data.cjs'

export function restoreDemo () {
  store.commit('setSiteIdInfo', { ...site })
  if (getAuthToken() && !store.state.userData) store.commit('setUserData', { ...account })
}
